import Tr from "translations/Translations";

const createItem = (value, key) => ({
    value,
    label: Tr(key),
})

export const SOURCE_TYPES = {
    SUPPLIER: "SUPPLIER",
    INITIATOR: "INITIATOR"
}

export default [
    createItem(SOURCE_TYPES.SUPPLIER, 'offerSourceType.supplier'),
    createItem(SOURCE_TYPES.INITIATOR, 'offerSourceType.initiator')
]